const locationAndContactStrings = {
    seoTitle: "La Estrellita | Ubicación y Contacto",
    pageTitle: "Ubicación y Contacto",
    callText: "Para comunicarte o hacer un pedido, llámanos al",
    contactUs: "Contáctanos",
    callBackupText: "Si no puede comunicarse con nosotros, intente con nuestro número de respaldo a ",
    locationText: "Nos encontramos en",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miercoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sabado",
    sunday: "Domingo",
    businessHours: "Horario de Negocio",
};

export default locationAndContactStrings;
